export const isMobile = () =>{
    // const windowHeight = window.innerHeight;
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //mobile
    return screenWidth < 1023;
}
